(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define("webapp-kube-summary", ["react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["webapp-kube-summary"] = factory(require("react"), require("react-dom"));
	else
		root["webapp-kube-summary"] = factory(root["react"], root["react-dom"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__121__) {
return 